import React, { useState } from 'react';
import cybercook from './../../LOGO-PRODUCTO-removebg-preview.png';

function Registras({apiCentral}) {
  const [formData, setFormData] = useState({
    nombreRestaurante: '',
    plan: '',
    numeroServicio: '',
    fechaPago: '',
    nombreResponsable: '',
    tamanoRestaurante: '',
    numeroMesas: '',
    dominio: '',
    telefono: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handlePost1 = async () => {
    try {
      // Convertir los campos numéricos a enteros
      const formDataToSend = {
        ...formData,
        numeroServicio: parseInt(formData.numeroServicio, 10),
        numeroMesas: parseInt(formData.numeroMesas, 10),
      };
  
      const config = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataToSend),
      };
  
      const response = await fetch(`${apiCentral}/api/restaurantes`, config);
      if (!response.ok) {
        throw new Error('Error en la respuesta del servidor');
      }
      const data = await response.json();
      console.log('Respuesta Restaurantes:', data);
    } catch (error) {
      console.error('Error en Restaurantes:', error);
    }
  };
  
  const handlePost2 = async () => {
    try {
      const config = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ nombreRestaurante: formData.nombreRestaurante }),
      };
  
      const response = await fetch(`${apiCentral}/api/estadisticas`, config);
      if (!response.ok) {
        throw new Error('Error en la respuesta del servidor');
      }
      const data = await response.json();
      console.log('Respuesta Estadísticas:', data);
    } catch (error) {
      console.error('Error en Estadísticas:', error);
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Esperar a que ambas promesas se resuelvan
    try {
      await Promise.all([handlePost1(), handlePost2()]);
  
      // Limpiar el formulario solo si ambas solicitudes son exitosas
      setFormData({
        nombreRestaurante: '',
        plan: '',
        numeroServicio: '',
        fechaPago: '',
        nombreResponsable: '',
        tamanoRestaurante: '',
        numeroMesas: '',
        dominio: '',
        telefono: ''
      });
  
      alert("Restaurante cargado a la base de datos correctamente.");
    } catch (error) {
      console.error('Error en la ejecución de POST:', error);
      alert("Hubo un error al cargar el restaurante.");
    }
  };
  

  return (
    <div>
      <form className="form-registro-new-restaurant" onSubmit={handleSubmit}>
        <div className="container-img-cybercook">
          <img src={cybercook} alt="Cybercook Logo" />
        </div>

        <div>
          <input
            type="text"
            placeholder="Nombre restaurante"
            name="nombreRestaurante"
            id="nombreRestaurante"  // Agregar id
            value={formData.nombreRestaurante}
            onChange={handleChange}
          />
        </div>

        <div>
          <select
            name="plan"
            id="plan"  // Agregar id
            value={formData.plan}
            onChange={handleChange}
          >
            <option value="">Seleccionar Plan</option>
            <option value="free">Free Plan</option>
            <option value="corriente">Corriente Plan</option>
            <option value="premium">Premium Plan</option>
          </select>
        </div>

        <div>
          <input
            type="number"
            placeholder="Numero del servicio en la escala"
            name="numeroServicio"
            id="numeroServicio"  // Agregar id
            value={formData.numeroServicio}
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="Fecha de ultimo pago DD/MM/AA"
            name="fechaPago"
            id="fechaPago"  // Agregar id
            value={formData.fechaPago}
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="Nombre responsable"
            name="nombreResponsable"
            id="nombreResponsable"  // Agregar id
            value={formData.nombreResponsable}
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="Tamaño restaurante"
            name="tamanoRestaurante"
            id="tamanoRestaurante"  // Agregar id
            value={formData.tamanoRestaurante}
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            type="number"
            placeholder="Numero de mesas"
            name="numeroMesas"
            id="numeroMesas"  // Agregar id
            value={formData.numeroMesas}
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="Dominio"
            name="dominio"
            id="dominio"  // Agregar id
            value={formData.dominio}
            onChange={handleChange}
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="telefono"
            name="telefono"
            id="telefono"  // Agregar id
            value={formData.telefono}
            onChange={handleChange}
          />
        </div>
        <div className="container-btn-form-new-restaurant">
          <button type="submit">Registrar</button>
        </div>
      </form>
    </div>
  );
}

export default Registras;
